














































































































































import { computed, defineComponent, onMounted, ref, watch } from '@vue/composition-api';
import { useAdCampaign } from '@/bundles/Ad/composables/useAdCampaign';
import { useAdCampaignItem } from '@/bundles/Ad/composables/useAdCampaignItem';
import { IAdCampaignItem } from '@/bundles/Ad/interfaces';
import { debounce } from '@/bundles/App/helpers';

import AdCampaignEditForm from '@/bundles/Ad/components/AdCampaignEditForm.vue';
import AdItemEditForm from '@/bundles/Ad/components/AdItemEditForm.vue';
import AdItemCreateForm from '@/bundles/Ad/components/AdItemCreateForm.vue';
import draggable from 'vuedraggable';

export default defineComponent({
  name: 'AdAdminCampaignView',

  components: {
    AdCampaignEditForm,
    AdItemEditForm,
    AdItemCreateForm,
    draggable,
  },

  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },

  setup (props) {
    const { getItemLoading, adCampaign, getCampaign } = useAdCampaign();
    onMounted(async () => {
      await getCampaign(+props.id);
    });

    const { resetAdItem, adCampaignItem, unassignAdItem, unassignLoading, bulkUpdateOrder } = useAdCampaignItem();

    const campaignItems = computed({
      get: () => adCampaign.value.items || [],
      set: (value) => {
        if (adCampaign.value.items) {
          adCampaign.value.items = value;
          debouncedUpdateItemsOrder();
        }
      }
    });

    const isInitialLoad = ref(true);
    watch(() => adCampaign.value.items, () => {
      if (isInitialLoad.value && adCampaign.value.items?.length) {
        isInitialLoad.value = false;
      }
    });

    async function updateItemsOrder() {
      if (isInitialLoad.value) return;

      campaignItems.value.forEach((item, index) => {
        item.order = index;
      });

      const payload = {
        items: campaignItems.value.map((item) => ({
          id: item.id,
          order: item.order!
        }))
      };

      await bulkUpdateOrder(payload);
    }

    const debouncedUpdateItemsOrder = debounce(updateItemsOrder, 3000);

    const showAdItemEditForm = ref(false);
    watch(() => showAdItemEditForm.value, function (value) {
      if (!value) {
        resetAdItem();
      }
    });
    function openEditDialog (item: IAdCampaignItem) {
      adCampaignItem.value = item;
      showAdItemEditForm.value = true;
    }

    const showAdItemCreateForm = ref(false);
    function unassignAdItemWrapper (id: number) {
      confirm('This action will remove ad item from campaign, are you sure?') && (async function () {
        await unassignAdItem(+props.id, { item_ids: [id] });
        await getCampaign(+props.id);
      })();
    }

    return {
      getItemLoading,
      adCampaign,
      campaignItems,
      adCampaignItem,
      showAdItemEditForm,
      showAdItemCreateForm,
      unassignLoading,
      unassignAdItemWrapper,
      getCampaign,
      openEditDialog,
    };
  },
});
